import { useEffect, useState } from 'react'
import { fetchTimezoneFromLocation } from 'dataSource/ProviderSearch'
import { matchTimezoneFromList } from 'app/ProviderSearch/utils'

type FetchTimezoneFromLocationHookType = {
  latitude: string
  longitude: string
  allowTimezoneAPICall?: boolean
}

type FetchTimezoneFromLocationReturnType = {
  timeZoneFetchedFromLocation: TimeZone
  fetchTimeZoneLoading: boolean
}

const useFetchTimezoneFromLocation = ({
  latitude,
  longitude,
  // Provides control to the parent component that's using this on when to make the API call
  allowTimezoneAPICall = true,
}: FetchTimezoneFromLocationHookType): FetchTimezoneFromLocationReturnType => {
  const [timeZoneFetchedFromLocation, setFetchedTimezone] = useState<TimeZone>(
    null
  )
  // The first loading state would be determined from the props.
  // If all the values are valid it would mean that a API call would definetly be made.
  const [fetchTimeZoneLoading, setFetchTimeZoneLoading] = useState<boolean>(
    !!(latitude && longitude && allowTimezoneAPICall)
  )

  useEffect(() => {
    if (latitude && longitude && allowTimezoneAPICall) {
      setFetchTimeZoneLoading(true)
      fetchTimezoneFromLocation(latitude, longitude)
        .then((response) => {
          if (response?.timeZoneName) {
            const matchingTimezone = matchTimezoneFromList(
              response.timeZoneName,
              response.timeZoneId
            )

            if (matchingTimezone) {
              setFetchedTimezone(matchingTimezone)
            }
          }
        })
        .catch(() => {
          //No need to set any timezone
        })
        .finally(() => {
          setFetchTimeZoneLoading(false)
        })
    }
  }, [latitude, longitude, allowTimezoneAPICall])

  return {
    timeZoneFetchedFromLocation,
    fetchTimeZoneLoading,
  }
}

export default useFetchTimezoneFromLocation
